export default [
    {
        path: '/admin/academic/candidate-certificates',
        name: 'candidate-certificate',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/candidate-certificate/index.vue')
    }
]
